import { Helper } from '../../../js/util/helper';

export default class Footer {
  constructor( node ) {
    this.node = node;
    this.initLink();
    this.initClickEventHandler();
  }
  initClickEventHandler() {
    let containers = this.node.querySelectorAll( '.footer__content-container' );

    for ( let container of containers ) {
      container.children[ 0 ].addEventListener( 'click', () => {

        if ( window.innerWidth < 1024 ) {
          container.classList.toggle( 'footer__content-container--closed' );
          if ( container.classList.contains( 'footer__content-container--closed' )) {
            container.children[ 0 ].children[ 1 ].classList.add( 'collapsed' );
          } else {
            container.children[ 0 ].children[ 1 ].classList.remove( 'collapsed' );
          }
        }
      });
    }
  }
  initLink() {
    const width = window.innerWidth;
    let links = this.node.querySelectorAll( '.footer__headline-link' );

    if ( width < 1024 && links[ 0 ].hasAttribute( 'href' )) {
      this.removeHref( links );
    }

    window.addEventListener( 'resize', Helper.debounce(() => {

      if ( window.innerWidth < 1024 && links[ 0 ].hasAttribute( 'href' )) {
        this.removeHref( links );
      } else if ( window.innerWidth >= 1024 && !links[ 0 ].hasAttribute( 'href' )) {
        this.addHref( links );
      }
    }, 250 ));
  }
  removeHref( links ) {
    for ( let link of links ) {
      link.removeAttribute( 'href' );
    }
  }
  addHref( links ) {
    for ( let link of links ) {
      link.setAttribute( 'href', link.getAttribute( 'data-href' ));
    }
  }
}
